import { GlobalController } from 'src/shared/global/GlobalController'
import IndustrialMapPage from './IndustrialMapPage.vue'

const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}

export const routes = [
  {
    path: 'industrial-map',
    name: 'IndustrialMapPage',
    component: IndustrialMapPage,
    beforeEnter: ifAuthenticated
  }
]
